import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-input-coop-deli',
  templateUrl: './text-input-coop-deli.component.html',
  styleUrls: ['./text-input-coop-deli.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextInputCoopDeliComponent,
      multi: true,
    }
  ]
})
export class TextInputCoopDeliComponent implements OnInit, ControlValueAccessor {

  @ViewChild('input', { static: true }) input: ElementRef;
  @Input() subid: string = null;
  @Input() forcedEnabledMode: string = null;
  @Input() width: number | string;
  @Input() text: string = <string>'';
  @Input() maxChars: number = null;
  @Input() restrict: string = null;
  @Input() fullOnly: boolean = <boolean>false;
  @Input() halfOnly: boolean = <boolean>false;
  @Input() allowMultiLine: boolean = <boolean>true;
  @Input() toUpperCase: boolean = <boolean>false;
  @Input() editable: boolean = <boolean>true;
  @Input() tabEnabled: boolean = <boolean>true;
  @Input() tabindex: number = null;
  @Input() verticalScrollPolicy: string = <string>'auto';
  @Input() displayCountField: boolean = <boolean>true;
  @Input() counterWidth: string;
  @Input() disabled: boolean = <boolean>false;
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Output() focus: EventEmitter<any> = new EventEmitter<any>();
  count: string = null;

  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.redraw();
    this.input.nativeElement.setAttribute('id', `${this.subid}_sub`);
    this.input.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
    if (this.displayCountField && this.counterWidth && !this.width) {
      this.width = `calc(100% - ${this.counterWidth}`;
    }
  }

  writeValue(text: any): void {
    if (text !== this.text) {
      this.text = text;
    }
  }
  onChange(_: any): void { }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  onTouched(): void { }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private redraw(): void {
    if (this.displayCountField) {
      this.count = this.text.length.toString().padStart(this.maxChars.toString().length, '0') + '/' + this.maxChars;
    }
  }

  textChanged(): void {
    this.redraw();
  }

  setVerticalScrollPolicy(): string {
    if ('auto' === this.verticalScrollPolicy) {
      return this.verticalScrollPolicy;
    }
    else if ('on' === this.verticalScrollPolicy) {
      return 'scroll';
    }
    else if ('off' === this.verticalScrollPolicy) {
      return 'hidden';
    }
    else {
      return null;
    }
  }

  setFocus() {
    this.input.nativeElement.focus();
  }
}
